<ng-container *ngIf="message?.isActive">
<fuse-card class="p-8 min-h-20 no-document mb-8">
      <div class="flex ">
          <div class="w-8 mt-2">
            <mat-icon [class]="message.iconColor">{{message.icon}}</mat-icon>
          </div>
          <div id="editor" class = "min-h-16 max-h-48" ></div>       
      </div>
  </fuse-card>
</ng-container>